import { TextElementDto } from "@repo/api/overlays";

import { getHexWithOpacity } from "../../utils/color.ts";
import { useFont } from "../../utils/font.ts";

type Props = {
  element: TextElementDto;
  fontSize?: number;
};

export default function TextElement({ element, fontSize }: Props) {
  const loadedFontFamily = useFont({
    fontExternalId: element.typography.fontExternalId,
    fontWeight: element.typography.fontWeight,
    fontStyle: element.typography.fontStyle,
  });
  const textColor = getHexWithOpacity(
    element.color.color,
    element.color.opacity ?? element.opacity ?? 100,
  );

  return (
    <div
      style={{
        fontSize: fontSize ?? element.typography.fontSize,
        fontWeight: element.typography.fontWeight,
        fontStyle: element.typography.fontStyle,
        fontFamily: loadedFontFamily ?? element.typography.fontFamily,
        color: textColor,
      }}
    >
      {element.text}
    </div>
  );
}
